import { render, staticRenderFns } from "./creditNoteDetail.vue?vue&type=template&id=df134a6c"
import script from "./creditNoteDetail.vue?vue&type=script&lang=js"
export * from "./creditNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./creditNoteDetail.vue?vue&type=style&index=0&id=df134a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports